import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 30px;
	row-gap: 20px;
`;

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
`;

export { StyledContainer, StyledList };
